<template>
    <div>
        <div class="DescriptionContainer">
            <p v-html="product.description"></p>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters([
        'product',
      ])
    }
  };
</script>

<style>
    .DescriptionContainer {
        margin: 10px 0px 10px;
    }
</style>


// WEBPACK FOOTER //
// product-description.vue?4d163337